export default __webpack_public_path__ + "static/media/alter.1d38f005.png";